import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { BiChevronDown, BiChevronUp } from "@acme/ui";

export interface FaqItem {
    question: string;
    answer: string;
}

interface LandingFaqProps {
    title?: string;
    items: FaqItem[];
}

export const LandingFaq = ({ title = "Common Questions", items }: LandingFaqProps) => {
    const [openIndex, setOpenIndex] = useState<number | null>(0);
    const toggle = (index: number) => setOpenIndex(openIndex === index ? null : index);

    return (
        <section className="py-24 bg-gray-50 dark:bg-gray-900/30 transition-colors duration-300">
            <div className="container mx-auto px-4 max-w-3xl">
                <h2 className="text-3xl font-bold mb-12 text-center text-gray-900 dark:text-white">{title}</h2>
                <div className="flex flex-col gap-4">
                    {items.map((item, idx) => (
                        <div key={idx} className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-lg overflow-hidden transition-colors duration-300">
                            <button onClick={() => toggle(idx)} className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors">
                                <span className="font-semibold text-gray-800 dark:text-gray-200">{item.question}</span>
                                {openIndex === idx ? <BiChevronUp className="text-gray-500" /> : <BiChevronDown className="text-gray-500" />}
                            </button>
                            <AnimatePresence>
                                {openIndex === idx && (
                                    <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} className="overflow-hidden">
                                        <div className="px-6 pb-6 pt-0 text-gray-600 dark:text-gray-400">{item.answer}</div>
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
